module.exports = __webpack_public_path__ + "static/media/pic1.7b447f4a.png";